export default __webpack_public_path__ + "static/media/goldshell.a0bc379a.svg";